export const LOYALTY_TIERS_DEMO = [
  {
    id: 'tier_01', name: 'Bronze', slug: 'bronze', description: 'Tier de entrada — descuento básico',
    color: '#cd7f32', sortOrder: 1, defaultDurationDays: 30, stackableWithCoupons: false, isActive: true,
    benefits: [
      { id: 'b_01', type: 'discount_percent', config: { value: 5 }, sortOrder: 1, isActive: true },
    ],
  },
  {
    id: 'tier_02', name: 'Silver', slug: 'silver', description: 'Tier intermedio — incluye envío gratis',
    color: '#c0c0c0', sortOrder: 2, defaultDurationDays: 60, stackableWithCoupons: false, isActive: true,
    benefits: [
      { id: 'b_02', type: 'discount_percent', config: { value: 10 }, sortOrder: 1, isActive: true },
      { id: 'b_03', type: 'free_shipping',    config: {},            sortOrder: 2, isActive: true },
    ],
  },
  {
    id: 'tier_03', name: 'Gold', slug: 'gold', description: 'Tier premium — acceso anticipado y mayor descuento',
    color: '#ffd700', sortOrder: 3, defaultDurationDays: 90, stackableWithCoupons: true, isActive: true,
    benefits: [
      { id: 'b_04', type: 'discount_percent', config: { value: 15 }, sortOrder: 1, isActive: true },
      { id: 'b_05', type: 'free_shipping',    config: {},            sortOrder: 2, isActive: true },
      { id: 'b_06', type: 'early_access',     config: { hoursBeforeDrop: 24 }, sortOrder: 3, isActive: true },
    ],
  },
]

export const LOYALTY_CODES_DEMO = [
  { id: 'lc_01', code: 'BRZ-2J89', tierId: 'tier_01', tierName: 'Bronze', batchId: 'batch_01', expiresAt: '2026-12-31', redeemedByCustomerId: null,    redeemedByEmail: null,                     redeemedAt: null,              createdAt: '2026-04-10', status: 'active' },
  { id: 'lc_02', code: 'BRZ-7K2A', tierId: 'tier_01', tierName: 'Bronze', batchId: 'batch_01', expiresAt: '2026-12-31', redeemedByCustomerId: 'cus_01', redeemedByEmail: 'cliente1@gmail.com',     redeemedAt: '2026-04-22',      createdAt: '2026-04-10', status: 'redeemed' },
  { id: 'lc_03', code: 'SLV-PQ4M', tierId: 'tier_02', tierName: 'Silver', batchId: 'batch_02', expiresAt: '2026-09-30', redeemedByCustomerId: null,    redeemedByEmail: null,                     redeemedAt: null,              createdAt: '2026-04-15', status: 'active' },
  { id: 'lc_04', code: 'SLV-XR9Z', tierId: 'tier_02', tierName: 'Silver', batchId: 'batch_02', expiresAt: '2026-09-30', redeemedByCustomerId: 'cus_03', redeemedByEmail: 'andres@example.com',     redeemedAt: '2026-04-30',      createdAt: '2026-04-15', status: 'redeemed' },
  { id: 'lc_05', code: 'GLD-VIP1', tierId: 'tier_03', tierName: 'Gold',   batchId: null,        expiresAt: null,         redeemedByCustomerId: 'cus_05', redeemedByEmail: 'sofia@example.com',      redeemedAt: '2026-03-01',      createdAt: '2026-02-20', status: 'redeemed' },
  { id: 'lc_06', code: 'GLD-VIP2', tierId: 'tier_03', tierName: 'Gold',   batchId: null,        expiresAt: '2025-12-31', redeemedByCustomerId: null,    redeemedByEmail: null,                     redeemedAt: null,              createdAt: '2025-11-01', status: 'expired' },
]

export const LOYALTY_MEMBERS_DEMO = [
  { id: 'mb_01', customerId: 'cus_01', customerEmail: 'cliente1@gmail.com', customerName: 'Sebastián Lozano', tierId: 'tier_01', tierName: 'Bronze', tierColor: '#cd7f32', codeId: 'lc_02', activatedAt: '2026-04-22', expiresAt: '2026-05-22', isActive: true },
  { id: 'mb_02', customerId: 'cus_03', customerEmail: 'andres@example.com', customerName: 'Andrés Pérez',     tierId: 'tier_02', tierName: 'Silver', tierColor: '#c0c0c0', codeId: 'lc_04', activatedAt: '2026-04-30', expiresAt: '2026-06-29', isActive: true },
  { id: 'mb_03', customerId: 'cus_05', customerEmail: 'sofia@example.com',  customerName: 'Sofía Rodríguez',  tierId: 'tier_03', tierName: 'Gold',   tierColor: '#ffd700', codeId: 'lc_05', activatedAt: '2026-03-01', expiresAt: '2026-05-30', isActive: true },
]

export const LOYALTY_STATS_DEMO = {
  activeTiers: 3,
  activeMembers: 3,
  totalCodes: 6,
  redeemedCodes: 3,
}
